import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { trpc } from '@/trpc/client';

/**
 * Redirects the user if their session has expired. This is a pretty rudimental session guard. Once we've updated to
 * Next.js 13.3 (PR open) we can move this entire journey into a layout within the app directory.
 */
export const useSessionGuard = () => {
  const user = trpc.auth.session.useQuery();
  const router = useRouter();

  useEffect(() => {
    if (user.isLoading) return;

    if (user.error?.data?.code === 'FORBIDDEN') {
      router.push('/account/login');
    }
  }, [user.error?.data?.code, router, user.isLoading, router.asPath]);
};
